package api.service.adminProfile

import api.data.response.DataAdminProfile
import firebaseAuth
import firebaseFirestore

object ImplServiceAdminProfile: ServiceAdminProfile{
    override suspend fun getAdminProfile(): DataAdminProfile? {
        val adminData = DataAdminProfile()
        val userId = firebaseAuth.currentUser?.uid.toString()
        val data = firebaseFirestore.collection("Admins").document(userId).get()
        return if (data.exists){
            adminData.apply {
                this.userId = data.get("userId")
                this.firstName = data.get("firstName")
                this.lastName = data.get("lastName")
                this.email = data.get("email")
                this.profilePhotoUrl = data.get("profilePhotoUrl")
                this.phone = data.get("phone")
            }
        } else{
            null
        }
    }

    override suspend fun updateAdminProfile(adminProfile: DataAdminProfile): Boolean {
        TODO("Not yet implemented")
    }



}